import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://admin.krestapay.in/api",
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token =  localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isAuthRoute = error.config?.url?.includes("/auth/");
    const isKycRoute  = error.config?.url?.includes("/kyc/");
    if (error.response?.status === 401 && !isAuthRoute && !isKycRoute) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default api;
